export default __webpack_public_path__ + "static/media/896.c8b95a78.gif";